/* T8 Spin to Win — opens after a delay (once: snoozed after a close, hidden after a spin), draws the wheel from the
   segment list, validates the WhatsApp number, picks a segment by weight, spins the wheel onto it, shows the code
   (copy / apply via /discount/CODE) or the no-prize note, and sends the lead to the store's contact inbox. */
(function () {
  'use strict';
  var KEY = 't8-spin-v1';
  var COLORS = ['#801E22', '#C3884C', '#5B1518', '#B19152', '#994B4E', '#8A7140'];   // red-500, gold-500, red-700, gold-600, red-400, gold-700
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  var DAY = 864e5;

  function el(name, attrs) { var n = document.createElementNS('http://www.w3.org/2000/svg', name); for (var k in attrs) n.setAttribute(k, attrs[k]); return n; }

  function draw(svg, segs) {
    var n = segs.length, a = 360 / n, r = 100;
    svg.appendChild(el('circle', { r: 108, fill: '#F9F3EC' }));                       // ivory rim
    segs.forEach(function (s, i) {
      var a0 = (i * a - a / 2 - 90) * Math.PI / 180, a1 = (i * a + a / 2 - 90) * Math.PI / 180;
      var d = 'M0 0 L' + (r * Math.cos(a0)).toFixed(2) + ' ' + (r * Math.sin(a0)).toFixed(2) +
              ' A' + r + ' ' + r + ' 0 0 1 ' + (r * Math.cos(a1)).toFixed(2) + ' ' + (r * Math.sin(a1)).toFixed(2) + ' Z';
      var color = COLORS[i % COLORS.length];
      if (n % COLORS.length === 1 && i === n - 1) color = COLORS[2];                  // never two equal neighbours across the seam
      svg.appendChild(el('path', { d: d, fill: color }));
      var g = el('g', { transform: 'rotate(' + (i * a - 90) + ')' });
      var t = el('text', { x: 58, y: 0, 'text-anchor': 'middle' });
      t.textContent = s.label;
      g.appendChild(t); svg.appendChild(g);
    });
    for (var i = 0; i < n; i++) {                                                         // pegs on the rim between segments
      var p = (i * a - a / 2 - 90) * Math.PI / 180;
      svg.appendChild(el('circle', { cx: (104 * Math.cos(p)).toFixed(2), cy: (104 * Math.sin(p)).toFixed(2), r: 2.6, fill: '#C3884C' }));
    }
    svg.appendChild(el('circle', { r: 15, fill: '#F9F3EC' }));                        // hub
    svg.appendChild(el('circle', { r: 7, fill: '#801E22' }));
  }

  function pick(segs) {
    var total = segs.reduce(function (t, s) { return t + Math.max(0, s.weight); }, 0), x = Math.random() * total;
    for (var i = 0; i < segs.length; i++) { x -= Math.max(0, segs[i].weight); if (x < 0) return i; }
    return 0;
  }

  function init(root) {
    var box = (root || document).querySelector('[data-t8-spin]');
    if (!box || box.dataset.ready) return; box.dataset.ready = '1';
    if (box.parentElement !== document.body) document.body.appendChild(box);   // escape any stacking context
    var segs = []; try { segs = JSON.parse(box.querySelector('[data-t8-spin-segments]').textContent); } catch (e) {}
    if (!segs.length) return;
    var design = box.dataset.design === 'true';
    var state = read(), now = Date.now();
    if (!design && state) {
      if (state.spun && now - state.at < Number(box.dataset.repeat || 90) * DAY) return;
      if (!state.spun && now - state.at < Number(box.dataset.snooze || 3) * DAY) return;
    }

    var dialog = box.querySelector('.t8-spin__dialog'), wheel = box.querySelector('[data-t8-spin-wheel]');
    var form = box.querySelector('[data-t8-spin-form]'), phone = box.querySelector('[data-t8-spin-phone]');
    var err = box.querySelector('[data-t8-spin-error]'), go = box.querySelector('[data-t8-spin-go]');
    var consent = box.querySelector('[data-t8-spin-consent]'), result = box.querySelector('[data-t8-spin-result]');
    draw(box.querySelector('[data-t8-spin-svg]'), segs);

    var opener = null, spun = false;
    function open() { opener = document.activeElement; box.hidden = false; document.body.classList.add('t8-spin-open'); dialog.focus(); }
    function close() {
      if (box.hidden) return;
      box.hidden = true; document.body.classList.remove('t8-spin-open');
      if (!design && !spun) write({ spun: false, at: Date.now() });
      if (opener && opener.focus) opener.focus();
    }
    box.querySelectorAll('[data-t8-spin-close]').forEach(function (b) { b.addEventListener('click', close); });
    box.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    phone.addEventListener('input', function () { phone.value = phone.value.replace(/\D/g, '').slice(0, 10); phone.removeAttribute('aria-invalid'); err.hidden = true; });

    function sendLead(num, seg) {
      var f = document.getElementById('t8-spin-lead'); if (!f) return;
      var fd = new FormData(f);
      fd.set('contact[phone]', '+91' + num);
      fd.set('contact[body]', 'Spin to Win lead\nWhatsApp: +91 ' + num + '\nResult: ' + seg.label + (seg.code ? ' (code ' + seg.code + ')' : '') +
        '\nMarketing consent: ' + (consent && consent.checked ? 'yes' : 'no') + '\nPage: ' + location.pathname);
      fetch(f.action || '/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (spun) return;
      var num = phone.value.replace(/\D/g, '');
      if (!/^[6-9]\d{9}$/.test(num)) { phone.setAttribute('aria-invalid', 'true'); err.hidden = false; phone.focus(); return; }
      spun = true; go.disabled = true; phone.disabled = true;
      var k = pick(segs), seg = segs[k], a = 360 / segs.length;
      var jitter = (Math.random() - .5) * a * .6;
      var deg = 360 * 6 + (360 - k * a) + jitter;                       // segment k's centre ends under the pointer (top)
      wheel.classList.add('is-spinning');
      requestAnimationFrame(function () { wheel.style.transform = 'rotate(' + deg + 'deg)'; });
      if (!design) write({ spun: true, at: Date.now(), label: seg.label, code: seg.code || '' });
      sendLead(num, seg);
      var done = false;
      function finish() {
        if (done) return; done = true;
        form.hidden = true; result.hidden = false;
        var win = box.querySelector('[data-t8-spin-win]'), lose = box.querySelector('[data-t8-spin-lose]');
        if (seg.code) {
          win.hidden = false;
          box.querySelector('[data-t8-spin-prize]').textContent = seg.label;
          box.querySelector('[data-t8-spin-code]').textContent = seg.code;
          box.querySelector('[data-t8-spin-apply]').href = '/discount/' + encodeURIComponent(seg.code) + '?redirect=' + encodeURIComponent(location.pathname + location.search);
        } else { lose.hidden = false; }
        var first = result.querySelector('button, a'); if (first) first.focus();
      }
      wheel.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 6200);   // in case transitionend never fires (reduced motion / background tab)
    });

    var copy = box.querySelector('[data-t8-spin-copy]');
    if (copy) copy.addEventListener('click', function () {
      var code = box.querySelector('[data-t8-spin-code]').textContent, label = copy.textContent;
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () {
        copy.textContent = copy.dataset.done || 'Copied'; setTimeout(function () { copy.textContent = label; }, 1600);
      }, function () {});
    });

    if (design) {
      document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(box) || e.target.querySelector('[data-t8-spin]') || /t8-spin/.test(e.target.id)) open(); });
      document.addEventListener('shopify:section:deselect', function () { close(); });
    } else {
      // the delay starts at the visitor's first scroll / tap / key, so the popup never covers a page nobody has touched yet
      // (no capture: a captured 'scroll' would also catch the carousels scrolling themselves; only the page's own scroll counts)
      var armed = false, evs = ['scroll', 'pointerdown', 'keydown', 'touchstart', 'mousemove'];
      var arm = function (e) {
        if (armed || (e && e.isTrusted === false)) return; armed = true;
        evs.forEach(function (ev) { window.removeEventListener(ev, arm); });
        setTimeout(open, Math.max(0, Number(box.dataset.delay) || 0) * 1000);
      };
      evs.forEach(function (ev) { window.addEventListener(ev, arm, { passive: true }); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
